<template>
  <ws-card :title="t('dashboard.recent-messages')" style="margin-top: 10px">
    <el-scrollbar v-if="recentMessagesList.length">
      <div class="card-wrap">
        <div
          class="card-item"
          v-for="(item, index) in recentMessagesList"
          :key="index"
        >
          <div class="card-item__img">
            <el-avatar
              v-if="!item.favicon"
              shape="square"
              src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"
            />
            <el-avatar v-else shape="square" :src="item.favicon" />
          </div>
          <div class="card-content">
            <div class="flex-between">
              <div class="card-item__name">{{ item.createdBy }}</div>
              <div class="card-item__date">
                {{ $filters.getCurrentSystemTimeFormat(item.createdTime) }}
              </div>
            </div>
            <div class="flex-between card-item__title">
              <span>{{ t('profile.title') }}: {{ item.title }}</span>
              <div class="card-item__date">
                <el-button
                  size="small"
                  @click="viewMessage(item.id)"
                  icon="el-icon-message"
                  round
                  >Detail</el-button
                >
              </div>
            </div>
            <div class="card-item__message">
              <!-- <span>{{ t('profile.content') }}: </span>
              <span> {{ item.content }}</span> -->
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div class="empty-wrap" v-else>
      <img
        class="empty-img"
        alt="emptyImg"
        src="../../../../../static/img/empty-box.png"
      />
    </div>
  </ws-card>
</template>
<script setup>
import WsCard from '@/base-ui/card'
import { ref } from 'vue'
import { useStore } from 'vuex'
import i18n from '@/i18n'
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()

const { t } = i18n.global

const recentMessagesList = ref([])

const initRecentMessage = async () => {
  const data = await store.dispatch('dashboard/getRecentUnreadMessage')
  recentMessagesList.value = data
}

const viewMessage = (id) => {
  router.push(`/system/message/readmessages/${id}`)
}
initRecentMessage()
</script>
<style lang="scss" scoped>
.card-wrap {
  height: 320px;
  .card-item {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 10px;
    .card-content {
      cursor: pointer;
      width: 100%;
      .card-item {
        &__name {
          color: rgb(52, 152, 219);
          margin-bottom: 10px;
          cursor: pointer;
          width: 290px;
        }
        &__date {
          color: grey;
          font-size: 12px;
        }
        &__title {
          color: #34495e;
          font-size: 14px;
          line-height: 32px;
        }
        &__message {
          color: #34495e;
          font-size: 14px;
          margin: 5px 0;
        }
      }
    }
    .flex-between {
      display: flex;
      justify-content: space-between;
    }
    &__img {
      width: 70px;
      margin-right: 10px;
    }
  }
}
.empty-wrap {
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
